var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.opp.source)?_c('iframe',{staticClass:"opp-source",style:({ height: _vm.iframeHeight }),attrs:{"id":"source","srcdoc":_vm.oppSource.source,"width":"100%"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }